import { get } from 'lodash/fp';
import PropTypes from 'prop-types';
import { compose, setPropTypes } from 'recompose';
import api from '../../../../../api';
import RouteError from '../../../../../routing/RouteError';
import { mapProps } from '../../../../hoc/recompose';
import { withData } from '../../../../hoc/withData';
import { useAppContext } from '../../../../hooks/useAppContext';
import { getCurrentUser } from '../../../../services/CurrentUser';
import LoadingIndicator from '../../components/LoadingIndicator';
import { getAuthorId } from '../../services/review';
import { getPreviewQuestionnaireActionUrls } from '../../services/url';
import { getNoReviewerOnPreviewQuestionnaireError } from '../../services/wording';
import NoAssessment from '../EditPage/NoAssessment';

const errorComponent = ({ error }) => {
    if (!error) {
        return null;
    }

    switch (get('response.data.message', error)) {
        case 'REVIEWER_NOT_FOUND':
            return <NoAssessment message={getNoReviewerOnPreviewQuestionnaireError()} />;
        default:
            return <RouteError error={error} />;
    }
};

export default compose(
    setPropTypes({
        cycleId: PropTypes.string.isRequired,
        location: PropTypes.object.isRequired,
    }),
    withData({
        pendingComponent: LoadingIndicator,
        errorComponent: errorComponent,
        resolve: {
            component: () => import(/* webpackChunkName: 'ReviewsEditPage' */ '../EditPage/presenter'),
        },
        observe: {
            review: ({ cycleId }) => api.reviews.getReviewPreviewQuestionnaire.createObservable(cycleId),
            assessments: ({ cycleId }) =>
                api.reviewAssessments.getAssessmentsForPreviewQuestionnaire.createObservable(cycleId),
        },
    }),
    mapProps(props => ({
        ...props,
        authorId: getAuthorId(props.location, props.review),
        previewQuestionnaireActions: getPreviewQuestionnaireActionUrls(props.cycleId),
        isQuestionnairePreview: true,
        currentUser: getCurrentUser(),
    }))
)(({ component: { default: Component }, ...props }) => <Component {...props} />);

export const PreviewEditForCycleModel = compose(
    setPropTypes({
        cycleModel: PropTypes.object.isRequired,
    }),
    withData({
        pendingComponent: LoadingIndicator,
        errorComponent: errorComponent,
        resolve: {
            component: () => import(/* webpackChunkName: 'ReviewsEditPage' */ '../EditPage/presenter'),
            review: ({ cycleModel }) => api.reviews.getPreviewReviewForCycleModel(cycleModel),
            assessments: ({ cycleModel }) => api.reviewAssessments.getPreviewAssessmentsForCycleModel(cycleModel),
        },
    })
)(({ component: { default: Component }, ...props }) => {
    const { user } = useAppContext();
    return <Component isQuestionnairePreview currentUser={user} {...props} authorId={user.id} />;
});
